export default __webpack_public_path__ + "static/media/copy.083a106e.svg";